/**
 * PriorAuthStatusSection - Output section for prior authorization status
 *
 * Displays PA on file, approval status, auth number, dates, and approved units.
 */

import { AccordionContent, AccordionItem, AccordionTrigger } from '@components/ui/accordion';
import React from 'react';

import { FieldPathProvider } from '../context';
import { Field, SectionTriggerScore } from './Field';

interface PriorAuthStatusSectionProps {
  data?: Record<string, unknown>;
  sectionId: string;
  entityType?: 'drug' | 'procedure';
}

export const PriorAuthStatusSection: React.FC<PriorAuthStatusSectionProps> = ({
  data,
  sectionId,
  entityType = 'drug',
}) => {
  const label = entityType === 'drug' ? 'Drug' : 'Procedure';

  return (
    <AccordionItem value={sectionId} className="border-b">
      <AccordionTrigger className="px-4 py-3 text-sm font-medium hover:bg-muted/50">
        <div className="flex items-center gap-2 flex-1">
          <span>{label} Prior Auth Status</span>
          <SectionTriggerScore subsectionKey="prior_auth_status" />
        </div>
      </AccordionTrigger>
      <AccordionContent className="px-4 pb-4">
        <FieldPathProvider prefix={`${entityType}.prior_auth_status`}>
          <div className="grid grid-cols-2 gap-x-4 gap-y-1">
            <Field
              label="PA Required"
              value={data?.prior_authorization_required}
              fieldId="prior_authorization_required"
            />
            <Field
              label="PA On File Exists"
              value={data?.prior_authorization_on_file_exists}
              fieldId="prior_authorization_on_file_exists"
            />
            <Field
              label="PA On File Status"
              value={data?.prior_authorization_on_file}
              fieldId="prior_authorization_on_file"
            />
            <Field
              label="Reference Number"
              value={data?.prior_authorization_reference_number}
              fieldId="prior_authorization_reference_number"
            />
            <Field
              label="Effective Date"
              value={data?.prior_authorization_effective_date}
              fieldId="prior_authorization_effective_date"
            />
            <Field
              label="End Date"
              value={data?.prior_authorization_end_date}
              fieldId="prior_authorization_end_date"
            />
            <Field
              label="Quantity Limits"
              value={data?.prior_authorization_quantity_limits}
              fieldId="prior_authorization_quantity_limits"
            />
            <Field
              label="Quantity Used"
              value={data?.prior_authorization_quantity_limits_used}
              fieldId="prior_authorization_quantity_limits_used"
            />
          </div>
        </FieldPathProvider>
      </AccordionContent>
    </AccordionItem>
  );
};
